module.exports = __webpack_public_path__ + "img/burger_menu.2cc78a27.svg";